import React, { useState, useEffect } from "react";
// eslint-disable-next-line no-unused-vars
import { Col, Container, Row, Button, Alert } from "react-bootstrap";
// eslint-disable-next-line no-unused-vars
import { Link } from "react-router-dom";
import "../../Style.css";
import List from "../../components/listing/List";
import BreadCrumb from "../../components/breadcrumb/BreadCrumb";
import Api from "../../components/api/Api";
import { useSelector } from "react-redux";
import axios from "axios";
import Notification, {
  showToast,
} from "../../../components/common/notification/Notification";
// eslint-disable-next-line no-unused-vars
import AllMessage from "../../../components/common/allMessage/AllMessage";
import Tr from "../../components/tr/Tr";
const Country = () => {
  const loggedInUser = useSelector((state) => state.auth.user);
  // eslint-disable-next-line no-unused-vars
  const userId = loggedInUser?.user?.id;
  const token = loggedInUser?.refreshToken;
  const countryApi = Api({
    url: "admin/countries",
  });

  // eslint-disable-next-line no-unused-vars
  const [showDeleteAlert, setShowDeleteAlert] = useState(false);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const handleDelete = async (itemId) => {
    console.log(`${baseUrl}/admin/deleteCountry/${itemId}`)
    try {
      const response = await axios.delete(
        `${baseUrl}/admin/deleteCountry/${itemId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      console.log(response);
      if (response.data.statusType === "SUCCESS") {
        setData(data.filter((item) => item.id !== itemId));
        showToast("Country deleted successfully", {
          type: "success",
        });
      } else {
        console.error(
          "Error 'deleting' item. Server responded with status:",
          response.status
        );
      }
    } catch (error) {
      console.error("Error 'deleting' item:", error);
    }

  };
  const [data, setData] = useState([]);
  const columns = [
    { displayName: "S.No.", render: (item, index) => index + 1 }, // Add a custom render function to generate the serial number

    { displayName: "Name", key: "name" },
  ];
  useEffect(() => {
    const fetchPropertyData = async () => {
      try {
        const responseData = await countryApi.fetchData();
        console.log(responseData);
        setData(responseData.data.countries);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPropertyData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const initialValues = {};
  const breadcrumbItems = [
    { label: "", link: "/", icon: "fa-solid fa-house" },
    { label: "Master", link: "/user" },
    { label: "Countries", link: "/country", active: true },
  ];
  return (
    <>
      <Notification />
      <div className="content-body2">
        <Container>
          <BreadCrumb items={breadcrumbItems} />
          <Row>
            <Col lg={12} md={12} sm={12}>
              {data?.length === 0 ? (
                <>
                  <Tr
                    columns={columns}
                    initialValues={initialValues}
                    title="No Country Found"
                    buttonName="Create"
                    btnLink="/country/add"
                    titleHeader="Countries"
                  />
                  {/* <Row>
                    <Col>
                      <AllMessage title="No Country Found" />
                    </Col>
                  </Row>
                  <Col
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      width: "100%",
                    }}
                  >
                    <Link to={"/country/add"} className="btn btn-primary">
                      Add Country
                    </Link>
                  </Col> */}
                </>
              ) : (
                <List
                  title="Countries"
                  data={data}
                  columns={columns}
                  button="Create"
                  route="country"
                  to="add"
                  handleDelete={handleDelete}
                />
              )}
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default Country;
